import { ServerData } from '@app/constants/server-data.constants';
import { UserEntitlementsData } from '@app/models/row-data.interface';

export const serverHelpers = {
  rowValues: handleEmployeesRowValues,
  accessLevel: handleUserAccessLevel
};

function handleEmployeesRowValues(row: UserEntitlementsData): UserEntitlementsData {
  const newRow = Object.assign({}, row);

  if (!!row.eligibility) {
    row.eligibility = ServerData.ClientEligible;
  } else if (row.eligibility === null) {
    row.eligibility = ServerData.ClientNotApplicable;
  } else {
    row.eligibility = ServerData.ClientNotEligible;
  }
  if (row.accessSettings === ServerData.ServerRoleAdmin) {
    row.accessSettings = ServerData.ClientRoleAdmin;
  } else {
    row.accessSettings = ServerData.ClientRoleUser;
  }
  if (!!row.activeStatus) {
    row.activeStatus = ServerData.ClientActive;
  } else {
    row.activeStatus = ServerData.ClientInactive;
    row.eligibility = ServerData.ClientNotApplicable;
  }

  return newRow;
}

function handleUserAccessLevel(accessLevel: string): string {
  switch (accessLevel) {
    case ServerData.ClientRoleAdmin:
      return ServerData.ServerRoleAdmin;
    case ServerData.ClientRoleUser:
      return ServerData.ServerRoleUser;
    default:
      return accessLevel;
  }
}
